import apiGet from './apiGet';

// NOTE: getData returns a Promise that will resolve(), either with the
// requested data or with a null if the call failed.  No rejects().
export default function getData(apiUrl, options) {
  return new Promise((resolve, reject) => {
    apiGet(apiUrl, options)
      .then((theData) => {
        resolve(theData);
      })
      .catch((error) => {
        let theData = null;
        resolve(theData);
      });
  });
}



// WEBPACK FOOTER //
// ./src/shared/functions/getData.js